import { Component, input } from '@angular/core'

@Component({
    selector: 'app-loading-state',
    templateUrl: './loading-state.component.html',
    styleUrls: ['./loading-state.component.scss'],
    standalone: true,
})
export class LoadingStateComponent {
    message = input('')
    diameter = input(40)
    color = input<'primary' | 'accent' | 'warn'>('primary')
    size = input<'small' | 'medium' | 'large'>('medium')
    fullscreen = input(false)
    /** Less padding, no card chrome — for tables, drawers, and inline panels. */
    compact = input(false)
}
